import { render } from "./SettingUp.vue?vue&type=template&id=acbc65c6&scoped=true"
import script from "./SettingUp.vue?vue&type=script&lang=js"
export * from "./SettingUp.vue?vue&type=script&lang=js"

import "./SettingUp.vue?vue&type=style&index=0&id=acbc65c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbc65c6"],['__file',"src/views/Auth/views/Register/SettingUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acbc65c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acbc65c6', __exports__)) {
    api.reload('acbc65c6', __exports__)
  }
  
  module.hot.accept("./SettingUp.vue?vue&type=template&id=acbc65c6&scoped=true", () => {
    api.rerender('acbc65c6', render)
  })

}


export default __exports__